import React from "react";
import { Link } from "react-router-dom";
import { AiOutlineHome } from "react-icons/ai";

function HomeLink({ to = "/", label = "Return to Home" }) {
  return (
    <div className="home-link-wrapper">
      <Link to={to} className="home-link">
        <AiOutlineHome className="home-link-icon" />
        <span>{label}</span>
      </Link>
    </div>
  );
}

export default HomeLink;
